import { Permission } from "@ticketingplatform/api/dist/__generated__/globalTypes";

export const hasPermissions = (
  userPermissions: Permission[],
  permissions: Permission[]
): boolean =>
  permissions.every((permission) => userPermissions.includes(permission));
